(function () {
  if (customElements.get("upgrade-set-selector")) return;

  customElements.define(
    "upgrade-set-selector",
    class UpgradeSetSelector extends HTMLElement {
      static get observedAttributes() {
        return ["data-upgrade-mode"];
      }

      attributeChangedCallback() {
        if (this._ready) this.applyMode();
      }

      disconnectedCallback() {
        this.unsub?.();
        this.unsub = undefined;
      }

      connectedCallback() {
        if (this._ready) return;

        try {
          this.data = JSON.parse(this.querySelector(".usm__data").textContent);
        } catch (e) {
          console.error("[upgrade-set-selector] failed to parse data island", e);
          this.hidden = true;
          return;
        }

        this.saveLabel = this.dataset.saveLabel || "";
        this.sectionId = this.dataset.sectionId;
        this.form = document.getElementById(this.dataset.formId);
        this.idInput = this.form
          ? this.form.querySelector('input[name="id"]')
          : null;

        this.viewSetLabel = this.dataset.viewSetLabel || "";
        this.justBedLabel = this.dataset.justBedLabel || "";

        this.list = this.querySelector("[data-usm-list]");
        this.rows = [];
        this.selectedKey = null;
        this.bedOptions = (this.data.selectedBedOptions || []).slice();
        this._boundList = false;
        this._boundSubmit = false;

        this.bindSubmit();
        this.bindVariantChange();

        this._ready = true;
        this.applyMode();
      }

      applyMode() {
        var mode = this.getAttribute("data-upgrade-mode") || "off";
        this.mode = mode;
        this.hidden = mode === "off";

        if (mode === "off") {
          if (this.list) this.list.innerHTML = "";
          this.selectedKey = null;
          this.rows = [];
          // UpCart (and Dawn) read input[name=id] directly — restore bed when hidden.
          this.releaseForm();
          return;
        }

        this.renderList();
        if (mode === "inline") {
          this.warnInlineForm();
          this.select("bed");
        } else if (mode === "link") {
          // Link mode must not leave a set variant id on the bed form.
          this.releaseForm();
        }
      }

      // Always re-query: product-info / section morphs can replace the input node.
      getIdInput() {
        if (!this.form) {
          this.form = document.getElementById(this.dataset.formId);
        }
        if (!this.form) return null;
        var input = this.form.querySelector('input[name="id"]');
        this.idInput = input;
        return input;
      }

      // UpCart intercepts the ATC click and never fires form `submit`, so steering
      // must happen on selection (and after finish/size sync) — not submit-only.
      steerForm(variant) {
        if (this.mode !== "inline" || !variant) return;
        var input = this.getIdInput();
        if (!input) return;
        input.value = variant.id;
        input.removeAttribute("disabled");
      }

      releaseForm() {
        var input = this.getIdInput();
        if (!input) return;
        var bedVariant = this.resolveVariant(this.optionByKey("bed"));
        if (!bedVariant) return;
        input.value = bedVariant.id;
        input.removeAttribute("disabled");
      }

      warnInlineForm() {
        if (this._formWarned) return;
        if (!this.form) {
          console.error(
            "[upgrade-set-selector] inline mode requires form #" +
              this.dataset.formId,
          );
          this._formWarned = true;
          return;
        }
        if (!this.idInput) {
          console.error(
            '[upgrade-set-selector] inline mode requires input[name="id"] in form #' +
              this.dataset.formId,
          );
          this._formWarned = true;
        }
      }

      renderList() {
        if (!this.list) return;

        var mode = this.mode;
        var options = this.data.options || [];
        var self = this;
        var html = "";
        var ariaLabel = this.justBedLabel || "Upgrade options";

        if (mode === "inline") {
          this.list.setAttribute("role", "radiogroup");
          this.list.setAttribute("aria-label", ariaLabel);
          options.forEach(function (option) {
            html += self.buildInlineRow(option);
          });
        } else {
          this.list.removeAttribute("role");
          this.list.removeAttribute("aria-label");
          options.forEach(function (option) {
            if (option.kind === "set") html += self.buildLinkRow(option);
          });
        }

        this.list.innerHTML = html;
        this.rows = Array.prototype.slice.call(
          this.list.querySelectorAll(".usm__row"),
        );

        this.bindListEvents();
        this.syncRows();
      }

      buildInlineRow(option) {
        var name = this.rowName(option);
        var media = this.buildMedia(option);
        var subline = this.buildSubline(option, name);
        return (
          '<button type="button" class="usm__row" role="radio" aria-checked="false" data-key="' +
          this.escapeAttr(option.key) +
          '">' +
          media +
          '<span class="usm__main">' +
          '<span class="usm__name">' +
          this.formatTitle(name) +
          "</span>" +
          subline +
          "</span>" +
          '<span class="usm__right price price--end">' +
          '<span class="usm__price price-item price-item--sale" data-usm-price></span>' +
          '<s class="usm__compare price-item price-item--regular" data-usm-compare hidden></s>' +
          '<span class="usm__save" data-usm-save hidden></span>' +
          "</span>" +
          "</button>"
        );
      }

      buildLinkRow(option) {
        if (!option.url) {
          console.error(
            "[upgrade-set-selector] set option missing url; skipping row",
            option.key,
          );
          return "";
        }
        var name = this.rowName(option);
        var media = this.buildMedia(option);
        var subline = this.buildSubline(option, name);
        return (
          '<a class="usm__row usm__row--link" data-key="' +
          this.escapeAttr(option.key) +
          '" href="' +
          this.escapeAttr(option.url) +
          '">' +
          media +
          '<span class="usm__main">' +
          '<span class="usm__name">' +
          this.formatTitle(name) +
          "</span>" +
          subline +
          '<span class="usm__view">' +
          this.escapeHtml(this.viewSetLabel) +
          '<svg class="usm__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"></polyline></svg>' +
          "</span>" +
          "</span>" +
          '<span class="usm__right price price--end">' +
          '<span class="usm__price price-item price-item--sale" data-usm-price></span>' +
          '<s class="usm__compare price-item price-item--regular" data-usm-compare hidden></s>' +
          '<span class="usm__save" data-usm-save hidden></span>' +
          "</span>" +
          "</a>"
        );
      }

      rowName(option) {
        if (option.kind === "bed" && this.justBedLabel) return this.justBedLabel;
        return option.name || "";
      }

      // Keep multi-word titles wrapping at spaces only — not mid-word or at "-".
      formatTitle(name) {
        return this.escapeHtml(name).replace(/-/g, "&#8209;");
      }

      buildSubline(option, name) {
        var subline = option.subline || "";
        if (!subline || subline === name) return "";
        return (
          '<span class="usm__subline">' + this.escapeHtml(subline) + "</span>"
        );
      }

      buildMedia(option) {
        if (!option.image) return "";
        return (
          '<span class="usm__media">' +
          '<img src="' +
          this.escapeAttr(option.image) +
          '" alt="' +
          this.escapeAttr(option.imageAlt || "") +
          '" loading="lazy" width="96" height="96">' +
          "</span>"
        );
      }

      bindListEvents() {
        if (!this.list || this._boundList) return;
        var self = this;
        this.list.addEventListener("click", function (e) {
          var row = e.target.closest(".usm__row");
          if (!row || !self.list.contains(row)) return;
          if (row.classList.contains("is-unavailable")) {
            e.preventDefault();
            return;
          }
          if (self.mode !== "inline") return;
          self.select(row.dataset.key);
        });
        this.list.addEventListener("keydown", function (e) {
          if (self.mode !== "inline") return;
          var row = e.target.closest(".usm__row");
          if (!row || !self.list.contains(row)) return;
          if (row.classList.contains("is-unavailable")) return;
          if (e.key === "ArrowDown" || e.key === "ArrowRight") {
            e.preventDefault();
            self.moveFocus(row, 1);
          } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
            e.preventDefault();
            self.moveFocus(row, -1);
          }
        });
        this._boundList = true;
      }

      bindSubmit() {
        if (!this.form || this._boundSubmit) return;
        var self = this;
        // Belt-and-suspenders for themes/apps that still submit the form (Dawn).
        // UpCart never reaches here — see steerForm().
        this.form.addEventListener(
          "submit",
          function (e) {
            if (self.mode !== "inline") return;
            var option = self.optionByKey(self.selectedKey);
            var variant = self.resolveVariant(option);
            // Selected set may have gone unavailable after a finish/size change;
            // fall back to bed (same as syncRows) rather than silently blocking.
            if (!variant && self.selectedKey !== "bed") {
              var bedVariant = self.resolveVariant(self.optionByKey("bed"));
              if (bedVariant) {
                self.select("bed");
                variant = bedVariant;
              }
            }
            if (!variant) {
              e.preventDefault();
              console.error(
                "[upgrade-set-selector] inline submit blocked: no available variant",
                {
                  selectedKey: self.selectedKey,
                  formId: self.dataset.formId,
                  bedOptions: self.bedOptions,
                },
              );
              return;
            }
            if (!self.getIdInput()) {
              e.preventDefault();
              console.error(
                "[upgrade-set-selector] cannot steer add-to-cart: variant id input missing",
              );
              return;
            }
            self.steerForm(variant);
          },
          true,
        );
        this._boundSubmit = true;
      }

      moveFocus(row, dir) {
        var i = this.rows.indexOf(row);
        if (i < 0 || !this.rows.length) return;
        var nextIdx = (i + dir + this.rows.length) % this.rows.length;
        var attempts = 0;
        while (attempts < this.rows.length) {
          var next = this.rows[nextIdx];
          if (!next.classList.contains("is-unavailable")) {
            next.focus();
            this.select(next.dataset.key);
            return;
          }
          nextIdx = (nextIdx + dir + this.rows.length) % this.rows.length;
          attempts++;
        }
      }

      bindVariantChange() {
        var self = this;
        var attach = function () {
          if (
            typeof subscribe !== "function" ||
            typeof PUB_SUB_EVENTS === "undefined"
          ) {
            return false;
          }
          self.unsub = subscribe(
            PUB_SUB_EVENTS.variantChange,
            function (event) {
              if (
                !event ||
                !event.data ||
                event.data.sectionId !== self.sectionId
              ) {
                return;
              }
              if (event.data.variant && event.data.variant.options) {
                self.bedOptions = event.data.variant.options.slice();
              }
              if (self.mode === "inline" || self.mode === "link") {
                self.syncRows();
              }
            },
          );
          return true;
        };

        if (!attach()) {
          if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", attach, {
              once: true,
            });
          }
        }
      }

      select(key) {
        for (var i = 0; i < this.rows.length; i++) {
          if (
            this.rows[i].dataset.key === key &&
            this.rows[i].classList.contains("is-unavailable")
          ) {
            return;
          }
        }
        this.selectedKey = key;
        this.rows.forEach(function (row) {
          var on = row.dataset.key === key;
          row.classList.toggle("is-selected", on);
          row.setAttribute("aria-checked", on ? "true" : "false");
        });
        this.syncRows();
      }

      optionByKey(key) {
        return (this.data.options || []).filter(function (o) {
          return o.key === key;
        })[0];
      }

      // Match by shared option NAME (case-insensitive). Prefer available among
      // matches. Fail closed: no match or sold-out-only matches → null (never
      // fall back to first / unavailable variant).
      resolveVariant(option) {
        if (!option || !option.variants || !option.variants.length) return null;

        var bedMap = {};
        var self = this;
        (this.data.bedOptionNames || []).forEach(function (name, i) {
          if (self.bedOptions[i] != null) {
            bedMap[String(name).toLowerCase()] = String(
              self.bedOptions[i],
            ).toLowerCase();
          }
        });

        function matches(variant) {
          var optionNames = option.optionNames || [];
          for (var i = 0; i < optionNames.length; i++) {
            var name = String(optionNames[i]).toLowerCase();
            if (bedMap[name] == null) continue;
            if (String(variant.options[i]).toLowerCase() !== bedMap[name]) {
              return false;
            }
          }
          return true;
        }

        var matchesList = option.variants.filter(matches);
        if (!matchesList.length) return null;

        var available = matchesList.filter(function (v) {
          return v.available;
        });
        return available[0] || null;
      }

      syncRows() {
        var self = this;
        this.rows.forEach(function (row) {
          var key = row.dataset.key;
          var option = self.optionByKey(key);
          var variant = self.resolveVariant(option);

          if (!variant) {
            row.classList.add("is-unavailable");
            row.hidden = true;
            if (row.tagName === "BUTTON" || row.tagName === "A") {
              row.setAttribute("aria-disabled", "true");
              row.tabIndex = -1;
            }
            if (row.tagName === "A") {
              row.removeAttribute("href");
            }
            return;
          }

          row.classList.remove("is-unavailable");
          row.hidden = false;
          if (row.tagName === "BUTTON" || row.tagName === "A") {
            row.removeAttribute("aria-disabled");
            // Inline radios: roving tabindex (set below). Links: restore default tab order.
            if (row.tagName === "A") {
              row.removeAttribute("tabindex");
            }
          }

          if (row.tagName === "A" && option && option.url) {
            row.setAttribute("href", option.url + "?variant=" + variant.id);
          }

          var priceEl = row.querySelector("[data-usm-price]");
          var compareEl = row.querySelector("[data-usm-compare]");
          var saveEl = row.querySelector("[data-usm-save]");

          if (priceEl) {
            priceEl.textContent = variant.priceMoney || "";
          }
          if (compareEl) {
            if (variant.compareMoney) {
              compareEl.textContent = variant.compareMoney;
              compareEl.hidden = false;
            } else {
              compareEl.textContent = "";
              compareEl.hidden = true;
            }
          }
          if (saveEl) {
            if (variant.saveMoney) {
              saveEl.textContent = self.saveLabel + " " + variant.saveMoney;
              saveEl.hidden = false;
            } else {
              saveEl.textContent = "";
              saveEl.hidden = true;
            }
          }
        });

        if (this.mode === "inline" && this.selectedKey) {
          for (var j = 0; j < this.rows.length; j++) {
            if (
              this.rows[j].dataset.key === this.selectedKey &&
              this.rows[j].classList.contains("is-unavailable")
            ) {
              this.select("bed");
              return;
            }
          }

          // product-info resets input[name=id] to the bed on finish/size change;
          // re-apply the selected set/bed variant so UpCart/Dawn ATC stay in sync.
          var selectedVariant = this.resolveVariant(
            this.optionByKey(this.selectedKey),
          );
          if (selectedVariant) this.steerForm(selectedVariant);
        }

        // APG radiogroup: one tab stop — selected available radio (else first available).
        if (this.mode === "inline") {
          var tabStopKey = null;
          for (var t = 0; t < this.rows.length; t++) {
            if (
              this.rows[t].dataset.key === this.selectedKey &&
              !this.rows[t].classList.contains("is-unavailable")
            ) {
              tabStopKey = this.selectedKey;
              break;
            }
          }
          if (tabStopKey == null) {
            for (var u = 0; u < this.rows.length; u++) {
              if (!this.rows[u].classList.contains("is-unavailable")) {
                tabStopKey = this.rows[u].dataset.key;
                break;
              }
            }
          }
          this.rows.forEach(function (row) {
            if (row.tagName !== "BUTTON") return;
            if (row.classList.contains("is-unavailable")) {
              row.tabIndex = -1;
              return;
            }
            row.tabIndex = row.dataset.key === tabStopKey ? 0 : -1;
          });
        }
      }

      escapeHtml(str) {
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      escapeAttr(str) {
        return this.escapeHtml(str).replace(/'/g, "&#39;");
      }
    },
  );
})();
